/**
 * Copyright (c) 2025-present, Bruno Carvalho de Araujo.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the LICENSE file in
 * the root directory of this source tree.
 */

import { type ComponentType } from 'react'
import BootstrapTabs, { TabsProps } from 'react-bootstrap/Tabs'
import styled from 'styled-components'

export type Props = {}

const Tabs: ComponentType<Props & TabsProps> = styled(BootstrapTabs)`
  & {
    border-bottom: 1px solid rgb(217, 217, 217);

    & .nav-link {
      border: none;
      color: #000;

      &.active {
        font-weight: 500;
        border-bottom: 2px solid #000;
      }
    }
  }
`

Tabs.defaultProps = {
  fill: true,
  variant: 'underline'
}

export default Tabs
